import { render, staticRenderFns } from "./FilterBlockStatistic.vue?vue&type=template&id=c8440f54&scoped=true"
import script from "./FilterBlockStatistic.vue?vue&type=script&lang=js"
export * from "./FilterBlockStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8440f54",
  null
  
)

export default component.exports